import React, { useEffect, useMemo } from 'react';
import { useAppDispatch, useWidgetParam } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { loadAdderState } from '@src/features/product';
import usePackageIdParam from '@src/hooks/usePackageIdParam';
import useBreakpoint from '@src/hooks/useBreakpoint';
import ProductAdderComponentSwitcher from './ProductAdderComponentSwitcher';

const ProductAdder = () => {
  const id = useWidgetId();
  const dispatch = useAppDispatch();
  const productId = useWidgetParam('product-id');
  const packageId = usePackageIdParam();

  const { isDesktop: autoSelectFirstProduct } = useBreakpoint();

  const enableModal = useWidgetParam('enable-modal');

  const showAsModal = useMemo(() => enableModal && enableModal == 'true', [enableModal]);

  useEffect(() => {
    if (productId || packageId) {
      dispatch(loadAdderState(id, productId, packageId, autoSelectFirstProduct));
    }
  }, [dispatch, id, packageId]);

  return <ProductAdderComponentSwitcher showAsModal={!!showAsModal} packageId={packageId} />;
};

export default ProductAdder;
